<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Traspaso masivo clientes
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Maestros</span>
      <span> /</span>
      <span>Traspaso masivo clientes</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form [formGroup]='formHeader' novalidate>
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body">
        <div class="col" style="max-width: 150px">
          <div class="md-form">
            <input value="" type="text" id="rutvende" class="form-control" placeholder="9.999.999-9" required #rutvende
              formControlName="rutVendedor" formatRut />
            <label for="rutvende">RUT del vendedor</label>
            <!-- <div *ngIf="
                  formHeader.get('rutVendedor').invalid &&
                  (formHeader.get('rutVendedor').dirty ||
                  formHeader.get('rutVendedor').touched)
              ">
              <mdb-error *ngIf="formHeader.get('rutVendedor').hasError('required')">
                Ingrese rut vendedor
              </mdb-error>
            </div> -->
          </div>
        </div>
        <div class="col d-flex" style="max-width: 300px">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="openModalSeleccionarVendedor()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" style="display: contents;">
            {{ vendedorSeleccionado?.razon_social }}
          </h6>
        </div>
        <!-- <div class="col" style="max-width: 250px;display: flex; align-items: center;">
          <div class="switch info-switch">
            <label>
              Inactivo
              <input formControlName="activo" type="checkbox" color="info" />
              <span class="lever"></span> Activo
            </label>
          </div>
        </div> -->
      </div>

      <h5 style="border-bottom: 1px solid #dee2e6">Mostrar clientes por IPT</h5>

      <app-ipt-panel (messageEvent)="receiveMessage($event)"></app-ipt-panel>

      <!-- <div class="row filtros-body">
        <div class="col" style="max-width: 150px">
          <div class="md-form">
            <input value="" type="text" id="clientasig" class="form-control" placeholder="3" required #rutvende
              formControlName="clientes_asig" onlyNumbers />
            <label for="clientasig">Clientes Asig.</label>
          </div>
        </div>
        <div class="col" style="max-width: 150px">
          <div class="md-form">
            <input value="" type="text" id="sucurasig" class="form-control" placeholder="3" required #rutvende
              formControlName="sucursales_asig" onlyNumbers />
            <label for="sucurasig">Sucursales Asig.</label>
          </div>
        </div>
      </div> -->

      <div class="row filtros-body">
        <div class="col" style="max-width: 150px">
          <div class="md-form">
            <input value="" type="text" id="rutclient" class="form-control" placeholder="9.999.999-9" required #rutvende
              formControlName="rutCliente" formatRut />
            <label for="rutclient">RUT de cliente</label>
          </div>
        </div>
        <div class="col d-flex" style="max-width: 300px">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="openModalSeleccionarCliente()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" style="display: contents">
            {{ clienteSeleccionado?.nombre }}
          </h6>
        </div>
      </div>
      <div class="row p-2 float-right">
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="Buscar(1)">
          <mdb-icon fas icon="search"></mdb-icon>
          Buscar
        </button>
      </div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div>
        <button mdbBtn type="button" color="info" size="sm" (click)="showModalMarcadoMasivo()" mdbWavesEffect>
          Marcación masiva
        </button>
        <button mdbBtn type="button" [disabled]="!CodeVendedorSend" color="info" (click)="showModalAsignarCliente()" size="sm" mdbWavesEffect>
          Asignar Cliente
        </button>
      </div>
      <div>
        <button mdbBtn type="button" color="info" [disabled]="ClientesSeleccion.length === 0" (click)="showModalGenerarIPT()" size="sm" mdbWavesEffect>
          Generar IPT
        </button>
        <button mdbBtn type="button" color="info" [disabled]="ClientesSeleccion.length === 0" (click)="showModalTrasnferenciaClienteVendedor()" size="sm"
          mdbWavesEffect>
          Transferir Cliente a Vendedor
        </button>
      </div>
    </div>
  </div>
</form>

<div class="card mb-2 wow detalle-cliente" *ngIf="listaMovimientos">
  <div class="card-body justify-content-between">
    <h5 style="border-bottom: 1px solid #dee2e6">Clientes</h5>

    <div class="table-responsive" *ngIf="listaMovimientos">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col" style="width: 1rem; min-width: 1rem; max-width: 2rem;">
              <mdb-checkbox (change)="checkAllChange($event)"></mdb-checkbox>
            </th>
            <th scope="col">RUT</th>
            <th scope="col">Nombre</th>
            <th scope="col">Dirección</th>
            <th scope="col">Rutas</th>
            <th scope="col">Territorio</th>
            <th scope="col">L</th>
            <th scope="col">M</th>
            <th scope="col">M</th>
            <th scope="col">J</th>
            <th scope="col">V</th>
            <th scope="col">S</th>
            <th scope="col">D</th>
            <th scope="col">Comuna</th>
            <th scope="col">Ciudad</th>
            <th scope="col">Tipo Cliente</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngIf="loading">
            <td colspan="100%" style="text-align: center">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
          </tr>
          <tr *ngIf="!loading && listaMovimientos?.length === 0">
            <td colspan="100%" style="text-align: center">
              No se encontró información
            </td>
          </tr>
          <tr *ngFor="let reg of listaMovimientos">
            <th scope="col">
              <mdb-checkbox [checked]="reg.additionalInfo.checked" (change)='checkDetalle(reg.additionalInfo, $event)'>
              </mdb-checkbox>
            </th>
            <td>{{reg.rutFormato | rut}}</td>
            <td>{{reg.razon_social}}</td>
            <td>{{reg.direccion_completa}}</td>
            <td>{{reg.ruta_nombre}}</td>
            <td>{{reg.nombreTerritorio}}</td>
            <td>
              <mdb-checkbox [checked]="reg.lunes"></mdb-checkbox>
            </td>
            <td>
              <mdb-checkbox [checked]="reg.martes"></mdb-checkbox>
            </td>
            <td>
              <mdb-checkbox [checked]="reg.miercoles"></mdb-checkbox>
            </td>
            <td>
              <mdb-checkbox [checked]="reg.jueves"></mdb-checkbox>
            </td>
            <td>
              <mdb-checkbox [checked]="reg.viernes"></mdb-checkbox>
            </td>
            <td>
              <mdb-checkbox [checked]="reg.sabado"></mdb-checkbox>
            </td>
            <td>
              <mdb-checkbox [checked]="reg.domingo"></mdb-checkbox>
            </td>
            <td>{{reg.nombrecomuna}}</td>
            <td>{{reg.nombreprovincia}}</td>
            <td>{{reg.tipo_cliente_nombre}}</td>
          </tr>
          <!-- <tr>
            <th scope="col">
              <mdb-checkbox [checked]="true"></mdb-checkbox>
            </th>
            <td>412412411-1</td>
            <td></td>
            <td>Andres Rodriguez</td>
            <td>204</td>
            <td>0001</td>
            <td>200</td>
            <td>
              <mdb-checkbox [checked]="true"></mdb-checkbox>
            </td>
            <td>
              <mdb-checkbox [checked]="false"></mdb-checkbox>
            </td>
            <td>
              <mdb-checkbox [checked]="false"></mdb-checkbox>
            </td>
            <td>
              <mdb-checkbox [checked]="true"></mdb-checkbox>
            </td>
            <td>
              <mdb-checkbox [checked]="false"></mdb-checkbox>
            </td>
            <td>
              <mdb-checkbox [checked]="false"></mdb-checkbox>
            </td>
            <td>
              <mdb-checkbox [checked]="false"></mdb-checkbox>
            </td>
            <td>Independencia</td>
            <td>Santiago</td>
            <td>ALM</td>
          </tr>
          <tr>
            <th scope="col">
              <mdb-checkbox [checked]="true"></mdb-checkbox>
            </th>
            <td>412412411-1</td>
            <td></td>
            <td>Andres Rodriguez</td>
            <td>204</td>
            <td>0001</td>
            <td>200</td>
            <td>
              <mdb-checkbox [checked]="true"></mdb-checkbox>
            </td>
            <td>
              <mdb-checkbox [checked]="false"></mdb-checkbox>
            </td>
            <td>
              <mdb-checkbox [checked]="false"></mdb-checkbox>
            </td>
            <td>
              <mdb-checkbox [checked]="false"></mdb-checkbox>
            </td>
            <td>
              <mdb-checkbox [checked]="false"></mdb-checkbox>
            </td>
            <td>
              <mdb-checkbox [checked]="true"></mdb-checkbox>
            </td>
            <td>
              <mdb-checkbox [checked]="true"></mdb-checkbox>
            </td>
            <td>Independencia</td>
            <td>Santiago</td>
            <td>ALM</td>
          </tr> -->
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>


  </div>
</div>

<div class="card mb-2 wow" *ngIf="listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <div style="display: flex; align-items: center;">
      <h6 *ngIf="areSelected">Clientes seleccionados ({{selected.length}})</h6>
    </div>

    <!-- <button mdbBtn type="button" color="success" mdbWavesEffect class="btn">
      Regresar
    </button> -->
  </div>
</div>

<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente [multiple]="false" queryType="ONLY_RUT" (onSelectSingle)="onClienteSeleccionado($event)"
  (onNotFound)="onClienteNoEncontrado()"></app-modal-seleccionar-cliente>

<!-- MODAL seleccionarVendedor -->
<app-modal-seleccionar-vendedor [multiple]="false" queryType="ONLY_RUT"
  (onSelectSingle)="onVendedorSeleccionado($event)" (onNotFound)="onVendedorNoEncontrado()">
</app-modal-seleccionar-vendedor>

<!-- MODAL marcacionMasiva -->
<app-traspaso-masivo-modal-marcado-masivo (RespforMMasivo)="UpdGrilla()" [enviarClientesSelecc]="seleccionForTraspasoMasivo"></app-traspaso-masivo-modal-marcado-masivo>

<!-- MODAL asignarCliente -->
<app-modal-asignar-cliente (BuscarxEvent)="UpdGrilla()" [multiple]="false" [enviarCodigoVendedor]="CodeVendedorSend" queryType="ONLY_RUT_VENDEDOR" (onSelectSingle)="onClienteSeleccionado($event)"
  (onNotFound)="onClienteNoEncontrado()"></app-modal-asignar-cliente>
<!-- MODAL generarIPT -->
<app-traspaso-masivo-modal-generar-ipt (EnviarInfo)="UpdGrilla()" [enviarRutVendedor]="rutVendedor" [enviarClientesSelecc]="ClientesSeleccion"></app-traspaso-masivo-modal-generar-ipt>

<!-- MODAL transferir -->
<app-traspaso-masivo-modal-transferencia-cliente-vendedor (RespTraspCliente)="UpdGrilla()" [enviarClientesSelecc]="ClientesSeleccion"></app-traspaso-masivo-modal-transferencia-cliente-vendedor>
